// @flow
import { showReportContent } from 'app/common/redux/actions/reportContent';

type ArgsType = {|
  id: string,
  viewParameter: ?$Values<PCONST.thrift.ViewParameterType>,
  viewType: ?$Values<PCONST.thrift.ViewType>,
|};

const reportComment = ({ id, viewParameter, viewType }: ArgsType) =>
  showReportContent({
    id,
    isProduct: false,
    isPromoted: false,
    videoDuration: null,
    viewParameter,
    viewType,
    type: 'aggregatedComment',
  });

export default reportComment;
